export class FilterObjectCatalog{
    description!: string;
}